import { authenticationTypes } from 'root/src/shared/constants/auth';
import { surveyEndpointIds } from 'root/src/shared/survey/constants';
export const isSatisfactionSurveyEmailedEndpoint = {
    [surveyEndpointIds.IS_SATISFACTION_SURVEY_EMAILED]: {
        authentication: authenticationTypes.authenticated,
    },
};
